import type { GrammarExercise } from "./grammar.js";

export const TENSES_EXERCISES: Record<string, GrammarExercise[]> = {
  "present-simple": [
    {
      question: "She ___ to work by bus every day.",
      options: ["go", "goes", "is going", "went"],
      correctIndex: 1,
      explanationVi:
        "Thói quen hằng ngày (every day) dùng thì hiện tại đơn; chủ ngữ ngôi thứ ba số ít nên động từ thêm -es.",
    },
    {
      question: "Hurry up! The train ___ at 6:30 tomorrow morning.",
      options: ["leaves", "left", "is leaving", "will have left"],
      correctIndex: 0,
      explanationVi:
        "Lịch trình cố định (giờ tàu chạy) dùng thì hiện tại đơn dù nói về tương lai: The train leaves at 6:30.",
    },
    {
      question: "My brother ___ coffee; he prefers tea.",
      options: ["don't drink", "isn't drinking", "doesn't drink", "didn't drink"],
      correctIndex: 2,
      explanationVi:
        "Sở thích/thói quen lâu dài dùng hiện tại đơn; phủ định với chủ ngữ ngôi ba số ít là does not + V nguyên thể.",
    },
    {
      question: "I ___ this song — turn the volume up!",
      options: ["am loving", "loved", "have loved", "love"],
      correctIndex: 3,
      explanationVi:
        "'Love' là động từ chỉ trạng thái (cảm xúc) nên không dùng ở thì tiếp diễn; diễn tả cảm xúc hiện tại dùng hiện tại đơn.",
    },
    {
      question: "The museum ___ at 9 a.m. and closes at 5 p.m.",
      options: ["open", "opens", "is opening", "opened"],
      correctIndex: 1,
      explanationVi:
        "Giờ mở cửa là lịch trình cố định nên dùng hiện tại đơn; 'the museum' là ngôi ba số ít nên động từ thêm -s (song song với 'closes').",
    },
  ],

  "present-continuous": [
    {
      question: "Please be quiet — the baby ___ right now.",
      options: ["sleeps", "slept", "is sleeping", "has slept"],
      correctIndex: 2,
      explanationVi:
        "Từ nhận biết 'right now' cho thấy hành động đang diễn ra tại thời điểm nói, dùng hiện tại tiếp diễn: is/are + V-ing.",
    },
    {
      question: "Look! It ___ outside.",
      options: ["rains", "is raining", "rained", "has rained"],
      correctIndex: 1,
      explanationVi:
        "'Look!' là tín hiệu của hiện tại tiếp diễn — hành động đang xảy ra ngay trước mắt người nói.",
    },
    {
      question: "We ___ the new client at 10 a.m. tomorrow — it's already in the calendar.",
      options: ["are meeting", "meet", "have met", "were meeting"],
      correctIndex: 0,
      explanationVi:
        "Kế hoạch đã sắp xếp trong tương lai gần (đã có trong lịch) dùng hiện tại tiếp diễn: are meeting.",
    },
    {
      question: "These days, more and more people ___ from home.",
      options: ["work", "worked", "have worked", "are working"],
      correctIndex: 3,
      explanationVi:
        "'These days' báo hiệu xu hướng đang thay đổi ở hiện tại, dùng hiện tại tiếp diễn chứ không dùng hiện tại đơn.",
    },
    {
      question: "I ___ this is a great idea.",
      options: ["am believing", "believes", "believe", "have believed"],
      correctIndex: 2,
      explanationVi:
        "'Believe' là động từ chỉ trạng thái (suy nghĩ) nên không dùng ở thì tiếp diễn; chủ ngữ 'I' dùng V nguyên thể.",
    },
  ],

  "present-perfect": [
    {
      question: "I ___ my keys — I can't open the door.",
      options: ["lost", "have lost", "lose", "had lost"],
      correctIndex: 1,
      explanationVi:
        "Hành động trong quá khứ có kết quả ảnh hưởng đến hiện tại (bây giờ không mở được cửa) dùng hiện tại hoàn thành: have + V3.",
    },
    {
      question: "She ___ in this company since 2020.",
      options: ["works", "worked", "has worked", "is working"],
      correctIndex: 2,
      explanationVi:
        "'Since 2020' cho thấy hành động bắt đầu trong quá khứ và kéo dài đến hiện tại, dùng hiện tại hoàn thành với since/for.",
    },
    {
      question: "We ___ the report yet, so we can't send it to the manager.",
      options: ["haven't finished", "didn't finish", "don't finish", "hadn't finished"],
      correctIndex: 0,
      explanationVi:
        "'Yet' là từ nhận biết của hiện tại hoàn thành phủ định — việc chưa hoàn thành tính đến thời điểm hiện tại.",
    },
    {
      question: "My parents ___ to Japan twice.",
      options: ["went", "go", "had gone", "have been"],
      correctIndex: 3,
      explanationVi:
        "Nói về kinh nghiệm (số lần trải nghiệm) mà không nêu thời điểm cụ thể trong quá khứ thì dùng hiện tại hoàn thành: have been.",
    },
    {
      question: "I ___ him three times this week, but he never answers.",
      options: ["called", "have called", "call", "had called"],
      correctIndex: 1,
      explanationVi:
        "'This week' là khoảng thời gian chưa kết thúc nên dùng hiện tại hoàn thành; nếu là 'last week' (đã kết thúc) mới dùng quá khứ đơn.",
    },
  ],

  "present-perfect-continuous": [
    {
      question: "She is out of breath because she ___.",
      options: ["runs", "has been running", "was running", "is running"],
      correctIndex: 1,
      explanationVi:
        "Kết quả còn thấy rõ ở hiện tại (đang thở dốc) do một hoạt động vừa kéo dài trước đó — dùng hiện tại hoàn thành tiếp diễn để nhấn mạnh quá trình.",
    },
    {
      question: "They ___ for the bus for 40 minutes and it still hasn't come.",
      options: ["wait", "are waiting", "have been waiting", "waited"],
      correctIndex: 2,
      explanationVi:
        "'For 40 minutes' + hành động kéo dài đến tận bây giờ: dùng have been + V-ing để nhấn mạnh thời lượng chờ đợi.",
    },
    {
      question: "I ___ three emails so far this morning.",
      options: ["have been writing", "am writing", "wrote", "have written"],
      correctIndex: 3,
      explanationVi:
        "Khi nêu số lượng hoàn thành cụ thể (three emails) thì dùng hiện tại hoàn thành đơn nhấn mạnh KẾT QUẢ, không dùng dạng tiếp diễn.",
    },
    {
      question: "It ___ since early morning, and the streets are still wet.",
      options: ["has been raining", "rains", "is raining", "rained"],
      correctIndex: 0,
      explanationVi:
        "'Since early morning' cho thấy hành động kéo dài từ quá khứ đến hiện tại; dùng has been + V-ing để nhấn mạnh quá trình mưa liên tục.",
    },
    {
      question: "He ___ too much lately, so he looks exhausted.",
      options: ["works", "worked", "is working", "has been working"],
      correctIndex: 3,
      explanationVi:
        "'Lately' là từ nhận biết của hiện tại hoàn thành tiếp diễn — quá trình làm việc kéo dài gần đây gây ra kết quả mệt mỏi hiện tại.",
    },
  ],

  "past-simple": [
    {
      question: "I ___ my grandmother two days ago.",
      options: ["have visited", "visited", "visit", "had visited"],
      correctIndex: 1,
      explanationVi:
        "'Ago' chỉ thời điểm xác định trong quá khứ, phải dùng quá khứ đơn, không dùng hiện tại hoàn thành.",
    },
    {
      question: "She ___ me an email yesterday, but I haven't replied yet.",
      options: ["has sent", "sends", "sent", "had sent"],
      correctIndex: 2,
      explanationVi:
        "'Yesterday' là mốc thời gian cụ thể đã kết thúc trong quá khứ nên dùng quá khứ đơn: sent (V2 của send).",
    },
    {
      question: "Where ___ you last night? I called you twice.",
      options: ["are", "was", "have been", "were"],
      correctIndex: 3,
      explanationVi:
        "'Last night' xác định thời điểm trong quá khứ; động từ to be với chủ ngữ 'you' ở quá khứ là 'were'.",
    },
    {
      question: "Mozart ___ more than 600 pieces of music.",
      options: ["wrote", "has written", "writes", "had written"],
      correctIndex: 0,
      explanationVi:
        "Nói về người đã mất — hành động thuộc về quá khứ đã khép lại hoàn toàn — nên dùng quá khứ đơn, không dùng hiện tại hoàn thành.",
    },
    {
      question: "Last Sunday we ___ dinner together, watched a movie, and went to bed early.",
      options: ["have had", "were having", "had", "have"],
      correctIndex: 2,
      explanationVi:
        "Chuỗi hành động liên tiếp trong một câu chuyện quá khứ (had... watched... went) đều dùng quá khứ đơn.",
    },
  ],

  "past-continuous": [
    {
      question: "I ___ a shower when the phone rang.",
      options: ["took", "was taking", "take", "have taken"],
      correctIndex: 1,
      explanationVi:
        "Hành động đang diễn ra (tắm) thì bị hành động ngắn (chuông điện thoại reo) xen vào: hành động nền dùng was/were + V-ing.",
    },
    {
      question: "While she ___ dinner, her husband was setting the table.",
      options: ["cooked", "cooks", "was cooking", "had cooked"],
      correctIndex: 2,
      explanationVi:
        "'While' nối hai hành động song song cùng diễn ra trong quá khứ, cả hai đều dùng quá khứ tiếp diễn.",
    },
    {
      question: "At 9 p.m. last night, we ___ TV in the living room.",
      options: ["watched", "watch", "have watched", "were watching"],
      correctIndex: 3,
      explanationVi:
        "'At 9 p.m. last night' là một thời điểm cụ thể trong quá khứ mà hành động đang diễn ra, dùng quá khứ tiếp diễn.",
    },
    {
      question: "They were playing football when it ___ to rain.",
      options: ["started", "was starting", "starts", "had started"],
      correctIndex: 0,
      explanationVi:
        "Trong cấu trúc 'was/were + V-ing... when...', hành động ngắn xen vào dùng quá khứ đơn: when it started to rain.",
    },
    {
      question: "What ___ you doing when the lights went out?",
      options: ["did", "are", "were", "was"],
      correctIndex: 2,
      explanationVi:
        "Hỏi về hành động đang diễn ra tại thời điểm quá khứ (khi mất điện) dùng quá khứ tiếp diễn; chủ ngữ 'you' đi với 'were'.",
    },
  ],

  "past-perfect": [
    {
      question: "By the time we arrived at the office, the meeting ___.",
      options: ["already started", "had already started", "has already started", "was already starting"],
      correctIndex: 1,
      explanationVi:
        "'By the time' + quá khứ đơn báo hiệu một hành động xảy ra TRƯỚC đó phải dùng quá khứ hoàn thành: had + V3.",
    },
    {
      question: "She couldn't pay for lunch because she ___ her wallet at home.",
      options: ["leaves", "has left", "had left", "was leaving"],
      correctIndex: 2,
      explanationVi:
        "Việc để quên ví xảy ra TRƯỚC việc không trả được tiền (couldn't pay), hành động xảy ra trước trong quá khứ dùng had + V3.",
    },
    {
      question: "After he ___ his homework, he went out to play.",
      options: ["had finished", "has finished", "was finishing", "finishes"],
      correctIndex: 0,
      explanationVi:
        "'After' cho biết hành động làm xong bài tập xảy ra trước hành động đi chơi (went out), nên dùng quá khứ hoàn thành.",
    },
    {
      question: "I didn't laugh at the joke because I ___ it many times before.",
      options: ["have heard", "heard", "was hearing", "had heard"],
      correctIndex: 3,
      explanationVi:
        "'Before' + mốc quá khứ (lúc nghe kể chuyện cười) cho thấy việc nghe đã xảy ra trước đó, dùng quá khứ hoàn thành had heard.",
    },
    {
      question: "The train ___ when we reached the station, so we waited for the next one.",
      options: ["left", "had left", "has left", "was leaving"],
      correctIndex: 1,
      explanationVi:
        "Tàu rời đi TRƯỚC khi chúng tôi đến ga — trong hai hành động quá khứ, hành động xảy ra trước dùng had + V3.",
    },
  ],

  "past-perfect-continuous": [
    {
      question: "They were exhausted because they ___ all day.",
      options: ["drive", "had driven", "had been driving", "are driving"],
      correctIndex: 2,
      explanationVi:
        "Nhấn mạnh QUÁ TRÌNH lái xe kéo dài (all day) trước một trạng thái trong quá khứ (were exhausted), dùng had been + V-ing.",
    },
    {
      question: "She ___ for the company for ten years before she quit.",
      options: ["worked", "has been working", "was working", "had been working"],
      correctIndex: 3,
      explanationVi:
        "'For ten years before' + mốc quá khứ (she quit): hành động kéo dài liên tục trước một thời điểm quá khứ dùng had been + V-ing.",
    },
    {
      question: "His eyes were red because he ___.",
      options: ["had been crying", "was crying", "has been crying", "cried"],
      correctIndex: 0,
      explanationVi:
        "Dấu vết còn lại trong quá khứ (mắt đỏ) do một quá trình kéo dài trước đó — dùng quá khứ hoàn thành tiếp diễn để nhấn mạnh quá trình khóc.",
    },
    {
      question: "By lunchtime, she ___ five reports, so her boss was very pleased.",
      options: ["had been writing", "had written", "was writing", "has written"],
      correctIndex: 1,
      explanationVi:
        "Khi nêu số lượng hoàn thành cụ thể (five reports) trước một mốc quá khứ, dùng quá khứ hoàn thành đơn (had + V3) nhấn mạnh kết quả, không dùng dạng tiếp diễn.",
    },
    {
      question: "The ground was wet because it ___ all night.",
      options: ["rained", "was raining", "has been raining", "had been raining"],
      correctIndex: 3,
      explanationVi:
        "'All night' nhấn mạnh khoảng thời gian mưa kéo dài trước thời điểm quan sát trong quá khứ (the ground was wet), dùng had been + V-ing.",
    },
  ],

  "future-simple-will": [
    {
      question: "The phone is ringing. — Don't worry, I ___ it.",
      options: ["am going to answer", "will answer", "answer", "am answering"],
      correctIndex: 1,
      explanationVi:
        "Quyết định được đưa ra NGAY LÚC NÓI (không có kế hoạch trước) dùng 'will'; 'be going to' chỉ dùng khi đã dự định từ trước.",
    },
    {
      question: "I promise I ___ anyone your secret.",
      options: ["don't tell", "am not telling", "won't tell", "didn't tell"],
      correctIndex: 2,
      explanationVi:
        "'Promise' là tín hiệu của lời hứa — một trong các cách dùng chính của will/won't (will not).",
    },
    {
      question: "I think our team ___ the match tomorrow.",
      options: ["will win", "wins", "is winning", "won"],
      correctIndex: 0,
      explanationVi:
        "'I think' + dự đoán không dựa trên dấu hiệu rõ ràng dùng thì tương lai đơn: will + V nguyên thể.",
    },
    {
      question: "That bag looks heavy. I ___ you carry it.",
      options: ["am helping", "help", "helped", "will help"],
      correctIndex: 3,
      explanationVi:
        "Lời đề nghị giúp đỡ được quyết định ngay tại thời điểm nói dùng 'will': I'll help you.",
    },
    {
      question: "Don't be sad — everything ___ fine.",
      options: ["is", "will be", "was", "has been"],
      correctIndex: 1,
      explanationVi:
        "Lời trấn an là một dự đoán về tương lai không có căn cứ cụ thể, dùng will + V nguyên thể (will be).",
    },
  ],

  "be-going-to": [
    {
      question: "We ___ a new apartment next month — we've already signed the contract.",
      options: ["will buy", "are going to buy", "buy", "bought"],
      correctIndex: 1,
      explanationVi:
        "Đã có KẾ HOẠCH từ trước (đã ký hợp đồng) nên dùng 'be going to', không dùng 'will' (quyết định tức thời).",
    },
    {
      question: "Look at those dark clouds! It ___ soon.",
      options: ["will rain", "rains", "is going to rain", "rained"],
      correctIndex: 2,
      explanationVi:
        "Dự đoán dựa trên DẤU HIỆU rõ ràng ở hiện tại (mây đen) dùng 'be going to', không dùng 'will' (dự đoán không căn cứ).",
    },
    {
      question: "Watch out! That bus is coming so fast — it ___ the car in front!",
      options: ["is going to hit", "will have hit", "hits", "has hit"],
      correctIndex: 0,
      explanationVi:
        "Có dấu hiệu rõ ràng trước mắt (xe buýt lao nhanh) cho thấy sự việc sắp xảy ra, dùng be going to + V.",
    },
    {
      question: "She ___ medicine at university next year; she has already chosen the school.",
      options: ["studies", "will have studied", "studied", "is going to study"],
      correctIndex: 3,
      explanationVi:
        "Dự định đã được lên kế hoạch từ trước (đã chọn trường) dùng be going to + V nguyên thể.",
    },
    {
      question: "He ___ his job — he told me about his plan last week.",
      options: ["quits", "is going to quit", "has quit", "was quitting"],
      correctIndex: 1,
      explanationVi:
        "Ý định đã có từ trước (đã kể về kế hoạch tuần trước) là cách dùng điển hình của 'be going to'.",
    },
  ],

  "future-continuous": [
    {
      question: "This time tomorrow, I ___ on a plane to Da Nang.",
      options: ["sit", "will sit", "will be sitting", "am sitting"],
      correctIndex: 2,
      explanationVi:
        "'This time tomorrow' là một mốc thời gian cụ thể trong tương lai mà hành động sẽ ĐANG diễn ra, dùng will be + V-ing.",
    },
    {
      question: "Don't call her at 8 p.m. — she ___ her favorite show then.",
      options: ["will be watching", "watches", "is watching", "will have watched"],
      correctIndex: 0,
      explanationVi:
        "Tại thời điểm xác định trong tương lai (at 8 p.m.), hành động xem phim sẽ đang diễn ra, dùng tương lai tiếp diễn.",
    },
    {
      question: "At 10 a.m. next Monday, the students ___ their final exam.",
      options: ["take", "took", "will have taken", "will be taking"],
      correctIndex: 3,
      explanationVi:
        "'At 10 a.m. next Monday' là mốc giờ cụ thể trong tương lai khi kỳ thi đang diễn ra, dùng will be + V-ing.",
    },
    {
      question: "When you arrive at noon, we ___ lunch, so come straight to the dining room.",
      options: ["will have", "will be having", "have", "are having"],
      correctIndex: 1,
      explanationVi:
        "Hành động ăn trưa sẽ đang diễn ra tại thời điểm bạn đến (at noon) trong tương lai, dùng tương lai tiếp diễn will be having.",
    },
    {
      question: "She ___ at the front desk all morning tomorrow, so you can find her there.",
      options: ["will be working", "works", "has worked", "will have worked"],
      correctIndex: 0,
      explanationVi:
        "'All morning tomorrow' chỉ khoảng thời gian trong tương lai mà hành động diễn ra liên tục, dùng will be + V-ing.",
    },
  ],

  "future-perfect": [
    {
      question: "By 2030, the city ___ the new metro line.",
      options: ["will complete", "will be completing", "will have completed", "completes"],
      correctIndex: 2,
      explanationVi:
        "'By + mốc thời gian tương lai' (by 2030) báo hiệu hành động sẽ HOÀN THÀNH trước mốc đó, dùng will have + V3.",
    },
    {
      question: "Don't worry — I ___ the report by Friday.",
      options: ["finish", "will have finished", "am finishing", "have finished"],
      correctIndex: 1,
      explanationVi:
        "'By Friday' nghĩa là trước hoặc đúng thứ Sáu công việc đã xong — hành động hoàn thành trước một mốc tương lai dùng will have + V3.",
    },
    {
      question: "By the time the guests arrive, we ___ everything for the party.",
      options: ["will have prepared", "will prepare", "are preparing", "have prepared"],
      correctIndex: 0,
      explanationVi:
        "'By the time + hiện tại đơn' chỉ mốc tương lai; việc chuẩn bị sẽ xong TRƯỚC khi khách đến nên dùng tương lai hoàn thành.",
    },
    {
      question: "Next June, we ___ married for twenty years.",
      options: ["will be", "have been", "were", "will have been"],
      correctIndex: 3,
      explanationVi:
        "Tính đến một mốc tương lai (next June), trạng thái kết hôn sẽ đạt đủ 20 năm — dùng will have been (tương lai hoàn thành của to be).",
    },
    {
      question: "He ___ all his exams by the end of next week.",
      options: ["will have taken", "will take", "takes", "has taken"],
      correctIndex: 0,
      explanationVi:
        "'By the end of next week' là mốc giới hạn trong tương lai mà mọi kỳ thi đã xong trước đó, dùng will have + V3.",
    },
  ],

  "future-perfect-continuous": [
    {
      question: "By December, she ___ at this company for ten years.",
      options: ["works", "will be working", "will have been working", "has been working"],
      correctIndex: 2,
      explanationVi:
        "'By + mốc tương lai' kết hợp 'for + khoảng thời gian' nhấn mạnh quá trình kéo dài liên tục đến mốc đó, dùng will have been + V-ing.",
    },
    {
      question: "By the time he retires, he ___ for over 30 years.",
      options: ["will have been teaching", "teaches", "will teach", "has taught"],
      correctIndex: 0,
      explanationVi:
        "'By the time he retires' + 'for over 30 years': nhấn mạnh thời lượng giảng dạy liên tục cho đến mốc tương lai, dùng will have been + V-ing.",
    },
    {
      question: "In September, we ___ in this house for a whole decade.",
      options: ["live", "are living", "lived", "will have been living"],
      correctIndex: 3,
      explanationVi:
        "Tính đến mốc tương lai (in September), quá trình sống ở đây kéo dài tròn 10 năm — dùng tương lai hoàn thành tiếp diễn để nhấn mạnh khoảng thời gian.",
    },
    {
      question: "By 5 p.m., the writer ___ ten pages of his new book.",
      options: ["will have been writing", "will have written", "will be writing", "writes"],
      correctIndex: 1,
      explanationVi:
        "Khi nêu số lượng hoàn thành cụ thể (ten pages) trước mốc tương lai, dùng tương lai hoàn thành ĐƠN (will have + V3) nhấn mạnh kết quả, không dùng dạng tiếp diễn.",
    },
    {
      question: "By the end of this month, they ___ the bridge for two years.",
      options: ["build", "built", "have been building", "will have been building"],
      correctIndex: 3,
      explanationVi:
        "'By the end of this month' + 'for two years' nhấn mạnh quá trình xây dựng kéo dài liên tục đến một mốc trong tương lai: will have been + V-ing.",
    },
  ],
};
